import {
  MinimalDeviceSourcesEnum,
  type MinimalDevice,
} from '@rtkwlf/asset-data-service';
import { AssetSource } from '@rtkwlf/rendall';
import { AssetType, type AssetRescanInput } from '@rtkwlf/rendall';

const RendalSourceMap = {
  [MinimalDeviceSourcesEnum.Agent]: AssetSource.Agent,
  [MinimalDeviceSourcesEnum.Iva]: AssetSource.Iva,
  [MinimalDeviceSourcesEnum.Eva]: undefined, // doesn't exist
};

export const buildAssetRescanData = (assetData: MinimalDevice[]) => {
  const assetRescanData: AssetRescanInput[] = [];
  assetData.forEach((asset) => {
    if (asset?.sources !== undefined) {
      const sources = asset.sources.reduce<AssetSource[]>((acc, source) => {
        const mapped = RendalSourceMap[source];
        if (mapped !== undefined) {
          acc.push(mapped);
        }
        return acc;
      }, []);

      if (sources.length > 0)
        assetRescanData.push({
          id: asset.id,
          type: AssetType.Device,
          sources,
        });
    }
  });

  return assetRescanData;
};
